import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { LoadingService } from './loading.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private loadingService = inject(LoadingService);
  private router = inject(Router);

  constructor() {
    // Listen for navigation events and reset loader
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      this.loadingService.forceStopLoading();
    });
  }
}
